module.exports = {"id":"177533","name":"Manuel da Costa","rating":"72","photo":"./data/images/photos/0/177533.png","club":{"name":"Medipol Başakşehir","logo":"./data/images/clubs/MedipolBasaksehir.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManueldaCosta0.json
// module id = 2690
// module chunks = 0